'use strict';
require(["jquery"]);
import "slick-carousel";
import AOS from "aos";

$.Body = $("body");
$.MenuFixed = $("#menu-fixed");
$.MediaDetect = $(".media-detect");
if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
  $.Body.on("mousewheel", function() {
      event.preventDefault();
      var wd = event.wheelDelta;
      var csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
  });
}
import MobileDetect from 'mobile-detect';
var detector = new MobileDetect(window.navigator.userAgent);
var mobile;
if (detector.phone() === null) {
  $.Body.attr({
      "data-device": "pc"
  });
} else {
  $.Body.attr({
      "data-device": "sp"
  });
}
$.BodyHtml = $("body,html");

$(".sec-1-campaign-0-slider-box").slick(
  {
    dots: true,
    appendDots: $(".sec-1-campaign-0-slider-nav"),
    prevArrow: $(".sec-1-campaign-0-slider-arrow-box .arrow-prev"),
    nextArrow: $(".sec-1-campaign-0-slider-arrow-box .arrow-next"),
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",

    responsive: [{

      breakpoint: 736,
      settings: {
        // centerPadding: "0.02vw"
      }

    }]
  }
);
$(".sec-1-campaign-0-btn-rules").click(
  function(){
    $.Body.attr({"data-modal":"campaign-01-rules"});
  }
);
$(".sec-1-campaign-1-btn-rules").click(
  function(){
    $.Body.attr({"data-modal":"campaign-02-rules"});
  }
);
$(".modal-campaign-close").click(
  function(e){
    $.Body.attr({"data-modal":"none"});
  }
);
$(".modal-campaign").click(
  function(e){
    if($(e.target).parentsUntil(".modal-campaign").length > 0){
      if(!$($(e.target).parentsUntil(".modal-campaign")[$(e.target).parentsUntil(".modal-campaign").length-1]).hasClass("modal-campaign-content")){
        $.Body.attr({"data-modal":"none"});
      }
    }
  }
);
var temp_del = 0;
$(".menu-ul a").click(
  function(e){
    e.preventDefault();
    var _temp = $(this).attr("data-anchor");
    $("[data-active]").attr({"data-active": _temp});
    
    // if( parseInt($.MediaDetect.width()) > 0 ){
    //   temp_del = parseInt($.MenuFixed.height());
    // } else {
    //   temp_del = 0;
    // }
    temp_del = parseInt($.MenuFixed.height());
    $.BodyHtml.animate({scrollTop: $( "#"+_temp).offset().top - temp_del },500);
  }
);
$(".go-top-in").click(
  function(){
    $.BodyHtml.animate({scrollTop: 0},500);
  }
);
$.sec_0_tab_box = $(".sec-0-tab-box");
$(".sec-0-tab-box li").click(
  function(){
    var _temp = $(this).index();
    $.sec_0_tab_box.attr({"data-tab": _temp});
  }
);

// $(".close-modal,#video-modal-close-bg").click(
//   function(){
//     $.Body.attr({"data-modal":"none"});
//     $("#video-modal-box-in").html('<iframe width="560" height="315" src="https://www.youtube.com/embed/4bfHKqLfTHk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>')
//     AOS.init();
//   }
// );
$.Body.attr({"data-modal":"none"});
AOS.init();